// Greek

export default {

  component: {
    jobAdList: {
      title: 'Ανοικτές θέσεις εργασίας',
      jobs: 'Θέσεις εργασίας',
      noJobAds: 'Αυτή τη στιγμή δεν υπάρχουν ανοικτές θέσεις εργασίας.',
    },

    jobAdCard: {
      openUntil: date => `Ανοικτή έως ${date}`,
    },

    jobAdGreetings: {
      thankYou: 'Σας ευχαριστούμε.',
      readyInfo: 'Η αίτησή σας έχει καταχωρηθεί και ο υπεύθυνος πρόσληψης θα επικοινωνήσει σύντομα μαζί σας.',
      luck: 'Καλή τύχη!',
    },

    jobAdSeeYou: {
      title: 'Σας ευχαριστούμε.',
      description: 'Η αίτησή σας αποθηκεύτηκε και σας έχουμε στείλει έναν σύνδεσμο για να συνεχίσετε την αίτηση αργότερα. ',
    },

    unpublished: {
      title: 'Αδημοσίευτη',
      info: 'Η αγγελία θέσης εργασίας δεν έχει δημοσιευτεί ακόμα.',
    },
  },

  page: {},

}
